import axios from 'axios';
import { mapState } from 'vuex';
import { STAC } from 'stac-js';
import Utils from '../utils';
import CONFIG from '../config';

const THUMBNAIL_API_BASE = CONFIG.thumbnailAPIEndpoint;

function getS3Key(thumbnail) {
  try {
    const s3Key = thumbnail.alternate?.s3?.href;
    if (s3Key && s3Key.startsWith('s3://')) {
      return s3Key.replace(/^s3:\/\/[^/]+\//, '');
    }
  } catch (e) { return null; }
}

export default {
  name: 'CardMixin',
  props: {
    showThumbnail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      resolvedThumbnailSrc: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(stacData) {
        this.resolvedThumbnailSrc = null;
        if (!stacData) { return; }
        const thumbnails = stacData.getThumbnails(true, 'thumbnail');
        if (thumbnails.length === 0) { return; }
        const t = thumbnails[0];
        const s3Key = getS3Key(t);
        if (!s3Key) { return; }
        const href = t.href;
        axios.get(`${THUMBNAIL_API_BASE}${s3Key}`)
          .then(response => {
            const mimeType = t.type || 'image/jpeg';
            this.resolvedThumbnailSrc = `data:${mimeType};base64,${response.data}`;
          })
          .catch(error => {
            console.error('Failed to load card thumbnail: ', s3Key, error);
          });
      }
    }
  },
  computed: {
    ...mapState(['cardViewMode', 'crossOriginMedia', 'defaultThumbnailSize']),
    isList() {
      return this.data && !this.data.isItem() && this.cardViewMode === 'list';
    },
    hasImage() {
      return this.showThumbnail && this.thumbnail;
    },
    thumbnail() {
      if (this.data) {
        let thumbnails = this.data.getThumbnails(true, 'thumbnail');
        if (thumbnails.length > 0) {
          let t = thumbnails[0];
          let width, height;
          const shape = t.getMetadata('proj:shape');
          if (Array.isArray(shape) && shape.length === 2) {
            [height, width] = shape;
          }
          else if (Array.isArray(this.defaultThumbnailSize) && this.defaultThumbnailSize.length === 2) {
            [height, width] = this.defaultThumbnailSize;
          }
          return {
            src: this.resolvedThumbnailSrc,
            alt: t.title,
            crossorigin: this.crossOriginMedia,
            right: this.isList,
            blankColor: "rgba(0, 0, 0, 0.125)",
            width,
            height,
            // for b-card-img-lazy
            "blank-width": width,
            "blank-height": height
          };
        }
      }
      return null;
    },
    keywords() {
      if (this.data) {
        return this.data.getMetadata('keywords') || [];
      }
      return [];
    },
    isDeprecated() {
      if (!(this.data instanceof STAC)) {
        return false;
      }
      // Items have deprecated in properties, catalogs/collections have it at the root
      const deprecated = this.data.isItem() ? this.data.properties?.deprecated : this.data.deprecated;
      return Boolean(deprecated);
    },
    hasDescription() {
      if (!(this.data instanceof STAC)) {
        return false;
      }
      // Use getMetadata which handles both items and catalogs
      const description = this.data.getMetadata('description');
      return Utils.hasText(description);
    },
    summarizeDescription() {
      if (!this.hasDescription) {
        return '';
      }
      const description = this.data.getMetadata('description');
      return Utils.summarizeMd(description, 300);
    }
  }
};